<template>
  <div>
    <h1 class="text-center titulo_user">{{data_form.empresa}}</h1>
    <h1 class="text-center d-flex justify-center titulo_aprobado align-center">
      <div>{{ $t("culminado.aprobado") }}</div>
      <div class="ml-4 video-success">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52 52"
          class="checkmark"
        >
          <circle
            data-v-1439b412=""
            cx="26"
            cy="26"
            r="25"
            fill="none"
            class="checkmark__circle"
          ></circle>
          <path
            data-v-1439b412=""
            fill="none"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
            class="checkmark__check"
          ></path>
        </svg>
      </div>
    </h1>
    <h3 class="text-center green--text">
      {{ $t("culminado.text_1") }}
    </h3>
    <h3 class="text-center">
      {{ $t("culminado.text_2") }}
    </h3>
    <h3 class="text-center">
      {{ $t("culminado.text_3") }}
    </h3>
  </div>
</template>

<script>
export default {
  props : {
    data_form : {
      type : Object,
      default : () => {}
    }
  }
};
</script>

<style></style>
